import React from "react";
import _ from "lodash";
import DefaultGameCreate from "./DefaultGameCreate";
import ChangeTeamsGameCreate from "./ChangeTeamsGameCreate";

const GameCreate = (props) => {
  const isChangingTeams = _.get(props, "location.state.record.isChangingTeams");
  if (isChangingTeams) {
    return <ChangeTeamsGameCreate {...props} />;
  } else {
    return <DefaultGameCreate {...props} />;
  }
};

export default GameCreate;
